import globalEventBus from 'toxilibs/event_bus_queued.js'
import sound from 'toxilibs/sound.js'
import adapter from 'toxilibs/soundjs_adapter.js'
import JsonSynchronizer from 'toxilibs/json_synchronizer.js'

let synchronizer = new JsonSynchronizer({
    localStoragePrefix: 'compute_it_sound'
})



let eventBus = globalEventBus('sounds')

eventBus.on('player wants to mute', mute)
eventBus.on('player wants to unmute', unmute)



sound.use(adapter)

sound.init({
    win:   './sounds/win',
    error: './sounds/error',
    move:  './sounds/player_move'
})



function mute () {
    synchronizer.updateKey('mute', true)
    sound.setMute(true)

    eventBus.emit('sound muted')
}


function unmute () {
    synchronizer.updateKey('mute', false)
    sound.setMute(false)

    eventBus.emit('sound unmuted')
}



function checkMuteInSynchronizer () {
    let isMute = synchronizer.getKey('mute') === 'true'
    if (isMute) {
        mute()
    } else {
        unmute()
    }
}



function eventToSound (eventName, soundName) {
    eventBus.on(eventName, function () {
        sound.play(soundName)
    })
}



eventToSound('player moved', 'move')

eventToSound('player valid animation ended', 'win')
eventToSound('player has done bad', 'error')

globalEventBus.on('application loaded', checkMuteInSynchronizer)

